import {Base, post} from './base'

/**
 * User api. See server documentation
 */
class User extends Base
{
	/// User id
	id = 0

	/// Username
	username = null

	/// Email
	email = null

	/**
	 * Default constructor
	 * 
	 * @param {Number} pk user primary key (id, username or email)
	 * @param {VuexStore} store vuex instance
	 */
	constructor(pk, store)
	{
		super(store)

		if (pk)
		{
			if (typeof pk === 'number') this.id = pk
			else this.username = this.email = pk
		}
	}

	/**
	 * Returns a specific user data
	 * 
	 * @param {String} id id, username or email
	 * @return {Promise} user data
	 */
	get(edges = '')
	{
		return this._get(`/u/${this.id || this.username}`, {edges})
	}

	/**
	 * 
	 */
	me(edges = '')
	{
		return this._get(`/u/me`, { edges })
	}

	/**
	 * 
	 */
	search(query, edges = '')
	{
		return this._get(`/u/search`, {query, edges})
	}

	/**
	 * Retrieve events for current month
	 * or custom time range
	 */
	getEvents()
	{
		return this._get(`/u/events`)
	}

	/**
	 * 
	 */
	getProducts(userid)
	{
		if (userid === undefined || userid === 0) {
			return this._get(`/u/products`, {edges: 'remaining'})
		}
		return this._get(`/u/${userid}/products`, {edges: 'remaining'})
	}

	/**
	 * 
	 */
	getVideos()
	{
		return this._get(`/u/library`);
	}
	/**
	 * 
	 */
	getUserById(id) {
		return this._get(`/user/${id}`)
	}
	/**
	 * 
	 */
	getSubscriptions(user_id, params = {}) {
		return this._get(`/u/${user_id}/subscriptions`, params)
	}

}

export default User
